{
  "version": 1,
  "asset_id": "cbe3cc7e-2df2-48f6-b4aa-b70d7bdaa03f",
  "project_id": "b5943ba6-0f61-4928-b23c-a966ef99f6df",
  "url": "/__l5e/assets-v1/cbe3cc7e-2df2-48f6-b4aa-b70d7bdaa03f/k-tip-new.png",
  "r2_key": "a/v1/b5943ba6-0f61-4928-b23c-a966ef99f6df/cbe3cc7e-2df2-48f6-b4aa-b70d7bdaa03f/k-tip-new.png",
  "original_filename": "k-tip-new.png",
  "size": 2658320,
  "content_type": "image/png",
  "created_at": "2026-09-23T21:17:24Z"
}
